/**
 * CameraAnnotationDemo — Insurance Claims use case.
 * Capture photo evidence with optional annotations.
 */
import React, { useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import CameraAnnotation from '../../components/useCases/CameraAnnotation';

export default function CameraAnnotationDemo({ onBack }) {
  const [value, setValue] = useState(null);

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Capture damage photos for insurance claims. Use camera or upload to gather evidence.
      </Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <CameraAnnotation
          value={value}
          onChange={(e) => setValue(e?.target?.value ?? e)}
          label="Damage evidence"
          height={280}
        />
      </Paper>
    </Box>
  );
}
